import "./inputs.scss";
import * as React from "react";
import { type HTMLProps } from "react";

interface Props extends HTMLProps<HTMLInputElement> {
    inputRef?: React.RefObject<HTMLInputElement> | React.RefCallback<HTMLInputElement>;
}

const ALLOWED_KEYS = [ ".", "Backspace", "Delete", "ArrowLeft", "ArrowRight", "-", "Tab" ];

export default class PercentageInput extends React.Component<Props> {
    protected handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        // This is implemented due to this React issue: https://github.com/facebook/react/issues/6556
        if(typeof this.props.onKeyDown === "function") {
            this.props.onKeyDown(e);
        }

        if(e.isDefaultPrevented()) {
            return;
        }

        const modifier = e.altKey || e.ctrlKey || e.metaKey;

        if(
            !modifier &&
            (
                !(
                    ALLOWED_KEYS.includes(e.key) ||
                    /[0-9]+/g.test(e.key)
                ) ||
                (
                    e.key === "." &&
                    ("" + this.props.value).indexOf(".") !== -1
                )
            )
        ) {
            e.preventDefault();
        }
    };

    public render(): React.ReactNode {
        const { className, inputRef, ...forwardProps } = this.props;

        const classes = [ "percentage-input" ];

        if(className) {
            classes.push(className);
        }

        return (
            <div className="percentage-input-wrapper">
                <input
                    {...forwardProps}
                    type="number"
                    step="any"
                    className={classes.join(" ")}
                    ref={inputRef}
                    onKeyDown={this.handleKeyDown}
                />
            </div>
        );
    }
}
